import { Autocomplete } from '@react-google-maps/api';
import React from 'react';
import { useTheme } from '@mui/material/styles';

interface Props {
    onPlaceSelect: (latLng: google.maps.places.PlaceResult) => void;
}

export interface AutoCompleteRefProps {
    clear: () => void;
}

export const GooglePlaceSearch = React.forwardRef<AutoCompleteRefProps, Props>(
    function GooglePlaceSearch({ onPlaceSelect }, ref) {
        const theme = useTheme();
        const autoComplete =
            React.useRef<google.maps.places.Autocomplete | null>(null);
        const inputRef = React.useRef<HTMLInputElement | null>(null);

        React.useImperativeHandle(ref, () => ({
            clear,
        }));

        const clear = () => {
            if (inputRef.current) {
                inputRef.current.value = '';
            }
        };

        const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
            autoComplete.current = autocomplete;
        };

        const onUnmount = () => {
            clear();
        };

        const onPlaceChanged = async () => {
            if (autoComplete !== null) {
                const results = autoComplete.current?.getPlace() ?? null;

                if (results) {
                    onPlaceSelect(results);
                }
            } else {
                console.log('Autocomplete is not loaded yet!');
            }
        };

        return (
            <Autocomplete
                onLoad={onLoad}
                onPlaceChanged={onPlaceChanged}
                onUnmount={onUnmount}
                types={['bar', 'night_club', 'restaurant']}
            >
                <input
                    type="text"
                    placeholder="Enter a Places name for map search"
                    // ref={r => {
                    //     inputRef.current = r;
                    // }}
                    ref={inputRef}
                    onFocus={e => {
                        e.target.setSelectionRange(0, -1);
                    }}
                    style={{
                        boxSizing: `border-box`,
                        border: `1px solid transparent`,
                        width: '300px',
                        height: `40px`,
                        padding: `0 12px`,
                        borderRadius: `3px`,
                        boxShadow: `0 1px 3px rgba(255, 255, 255, 0.3)`,
                        fontSize: `16px`,
                        outline: `none`,
                        background: theme.palette.background.paper,
                        textOverflow: `ellipses`,
                        position: 'absolute',
                        marginTop: 10,
                        marginLeft: -150,
                        left: '50%',
                        color: theme.palette.text.disabled,
                    }}
                />
            </Autocomplete>
        );
    }
);
